import { useMedia } from '../../../../hooks/useMedia';
import { OUTPUT_PANEL_BREAKPOINT_MEDIA_QUERY } from './constants';

export const useIsOutputInPanelBreakpointActive = () =>
  useMedia([OUTPUT_PANEL_BREAKPOINT_MEDIA_QUERY], [true], false);
